import {
  Button,
  FormControl,
  FormHelperText,
  MenuItem,
  Select,
  TextField,
  Typography,
} from '@mui/material';
import { Formik, Form, Field } from 'formik';
import { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';
import * as Yup from 'yup';
import useNotification from '../../../../hooks/useNotification';
import { postTCDetailsForDegree } from '../../../../features/student/studentSlice';
import api from '../../../../services/api';
import ToastNotification from '../../../UIElements/ToastNotification';
import { getClasses } from '../../../../features/classes/ClassSlice';
import { TCIdCheck } from '../../../../features/history/HistorySlice';
const initialData = {
  tcNumber: '',
  studentName: '',
  studentId: '',
  dob: '',
  guardianName: '',
  religion: '',
  category: '',
  leavingClass: '',
  firstLanguage: '',
  secondLanguage: '',
  optionalSubject: '',
  medium: '',
  firstAdmissionClass: '',
  dateOfJoining: '',
  qualified: '',
  scholarship: '',
  concession: '',
  reason: '',
  leavingDate: '',
  tcDate: '',
  conduct: '',
  signature: '',
};
export const ValidationSchema = Yup.object({
  tcNumber: Yup.number(),
  studentId: Yup.string().required('Student ID is required'),
  studentName: Yup.string().required('Student name is required'),
  guardianName: Yup.string().required('Guardian Name is required'),
  religion: Yup.string().required('Religion is required'),
  category: Yup.string().required('Category is required'),
  dob: Yup.string().required('Date of Birth is required'),

  leavingClass: Yup.string().required('Leaving class is required'),
  firstLanguage: Yup.string().required('First language is required'),
  secondLanguage: Yup.string().required('Second language is required'),
  optionalSubject: Yup.string(),

  medium: Yup.string().required('Mother Tongue and Medium are required'),
  dateOfJoining: Yup.string().required('Date of Joining is required.'),
  firstAdmissionClass: Yup.string().required(
    'First Admission Class is required',
  ),
  qualified: Yup.boolean().required('Required'),

  scholarship: Yup.boolean().required('Required'),
  concession: Yup.string().required('Concession field is required'),

  leavingDate: Yup.string().required('Leaving date is required'),
  reason: Yup.string().required('Leaving reason is required'),
  tcDate: Yup.string().required('TC date is required'),
  conduct: Yup.string(),
});
export default function VeerisettyCollegeDegree({ StudentId = 'STU88' }) {
  const [data, setData] = useState({ ...initialData });
  const [studentId, setStudentId] = useState('');
  const [classNames, setClassNames] = useState([]);
  const dispatch = useDispatch();
  const [isIdExists, setIsIdExists] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [isDownloading, setIsDownloading] = useState(false);
  const { notification, showSuccess, showError, hideNotification } =
    useNotification();
  async function downloadTC(searchParameters) {
    try {
      setIsDownloading(true);
      const fileResponse = await api({
        baseURL: process.env.REACT_APP_API_BASE_URL,
        url: `tc/download/${studentId}`,
        method: 'GET',
        responseType: 'blob',
        headers: searchParameters,
      });
      const blob = new Blob([fileResponse?.data], {
        type: fileResponse.headers['content-type'],
      });

      let filename = `${studentId}-TC.pdf`;
      const contentDisposition = fileResponse?.headers['content-disposition'];
      const match = contentDisposition?.match(/filename="?(.+)"?/);

      if (match?.[1]) filename = match[1];

      const url = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = url;
      link.download = filename;
      link.click();
      URL.revokeObjectURL(url);
    } catch (err) {
      showError('Error in Downloading the TC.');
      console.error('Download failed', err);
    } finally {
      setIsDownloading(false);
    }
  }
  async function retriveClasses() {
    try {
      const res = await dispatch(getClasses()).unwrap();
      const departmentNames = res.map((item) => ({
        label: item?.department,
        value: item?.department,
      }));
      setClassNames(departmentNames);
    } catch (error) {
      showError('Error in getting class details.');
    }
  }
  useEffect(() => {
    setStudentId(StudentId);
    if (classNames?.length == 0) retriveClasses();
  }, [StudentId]);
  return (
    <div>
      <Formik
        initialValues={data}
        validationSchema={ValidationSchema}
        enableReinitialize
        validateOnChange={true}
        validateOnBlur={true}
        onSubmit={async (values) => {
          try {
            setIsSubmitting(true);
            const resp = await dispatch(
              postTCDetailsForDegree(values),
            ).unwrap();
            if (resp.status === 200) {
              setStudentId(resp.data.studentId);
              setData(resp.data);
              showSuccess('TC details submitted successfully.');
            }
          } catch (error) {
            console.log(error);
            showError('Error in submitting the TC details.');
          } finally {
            setIsSubmitting(false);
          }
        }}
      >
        {({ values }) => (
          <Form>
            <div className=' bg-[#fffffa] relative  mx-auto  border p-8 rounded'>
              {/* TOP */}
              {(isSubmitting || isDownloading) && (
                <div className='absolute inset-0 z-10 flex items-center justify-center bg-white/80 opacity-80'>
                  <span className='text-lg font-semibold '>
                    {isSubmitting ? 'Submitting...' : 'Downloading...'}
                  </span>
                </div>
              )}
              <div className='flex flex-col text-center space-x-1'>
                <h2>BELLAMKONDA DEGREE COLLEGE</h2>
                <h6>C.S.PURAM, PRAKASAM (DT) - 523112</h6>
                <h6>AFFILIATED TO ANU UNIVERSITY - GUNTUR.</h6>
              </div>
              <h2 className='text-center text-[20px] font-bold underline'>
                FORM OF TRANSFER CERTIFICATE
              </h2>
              <h6 className='text-center'>FOR DEGREE COURSE</h6>
              <div className='flex justify-between mt-6 mb-3 flex-wrap gap-2'>
                {/* TC Number */}
                <div>
                  Transfer Certificate No :{' '}
                  {data?.tcNumber ? (
                    <b className='text-red-500'> {data?.tcNumber}</b>
                  ) : (
                    <small className='text-sm text-red-600'>
                      Generates automatically
                    </small>
                  )}
                </div>
                {/* Addmission Number */}
                <div>
                  <div className='flex gap-2 mr-2'>
                    <span className='text-nowrap'>Admission No :</span>{' '}
                    <Field name='studentId'>
                      {({ field, meta }) => (
                        <TextField
                          size='small'
                          className='w-40'
                          variant='standard'
                          {...field} // Spreads name, value, onChange, and onBlur
                          fullWidth
                          // Error handling:
                          error={meta.touched && Boolean(meta.error)}
                          helperText={meta.touched && meta.error}
                          onChange={(e) => {
                            field.onChange(e);
                            const value = e.target.value;
                            if (!value) setIsIdExists(false);
                          }}
                          onBlur={async (e) => {
                            field.onBlur(e);
                            if (e.target.value) {
                              const res = await dispatch(
                                TCIdCheck(e.target.value),
                              ).unwrap();
                              setIsIdExists(res);
                            } else {
                              setIsIdExists(false);
                            }
                          }}
                        />
                      )}
                    </Field>
                  </div>
                  {isIdExists && (
                    <div
                      id='transactionIdError'
                      className='mb-2 text-red-600 text-sm text-center'
                    >
                      Admission No already Exists
                    </div>
                  )}
                </div>
                {/* Date of TC Issuingdate */}
                <div className='flex gap-4 '>
                  <span className='text-nowrap'>Data : </span>{' '}
                  <DateField name='tcDate' />
                </div>
              </div>
              <div className='space-y-4 text-[16px] mt-4'>
                <FormRow num='1.' label='Name of The Student'>
                  <InputField name='studentName' />
                </FormRow>

                <FormRow num='2.' label='Name of The Parent / Guardian '>
                  {' '}
                  <InputField name='guardianName' />
                </FormRow>
                <FormRow num='3.' label='Nationality and Religion'>
                  {' '}
                  <InputField name='religion' />
                </FormRow>
                <FormRow
                  num='4.'
                  label='Whether the candidate belongs to S.Cs or S.Ts or Vimukta jathis other socially and Educationally backward classes specified in APERs is he a convert from the S Cs or The S.Ts? If so particulars thereof'
                >
                  <InputField name='category' />
                </FormRow>
                <FormRow
                  num='5.'
                  label='Date of Birth  as entered in the Admission Register'
                  name='dob'
                >
                  <DateField name='dob' />
                </FormRow>

                <FormRow
                  num='6.'
                  label='(a) Class in which the people was reading At the time of leaving.'
                >
                  <InputField name='leavingClass' />
                </FormRow>
                <FormRow num='' label='(b) First Language under Part - I'>
                  <InputField name='firstLanguage' />
                </FormRow>
                <FormRow num='' label='(c) Second Language under part - II'>
                  <InputField name='secondLanguage' />
                </FormRow>
                <FormRow num='' label='(d) Optionals under Part - III'>
                  <InputField name='optionalSubject' />
                </FormRow>
                <FormRow
                  num='7.'
                  label='Mother Tongue and Medium of Instruction'
                >
                  <SelectField
                    name='medium'
                    options={[
                      {
                        label: 'Telugu and English',
                        value: 'Telugu and English',
                      },
                      {
                        label: 'English and English',
                        value: 'English adn English',
                      },
                    ]}
                    placeholder={'Select Mother Tongue and Medium'}
                  />
                </FormRow>
                <FormRow
                  num='8.'
                  label='Date of admission to 1year Degree Course.'
                >
                  <DateField name='dateOfJoining' />
                </FormRow>
                <FormRow
                  num='9.'
                  label='Class and year in which the people was first Admitted into the College (I year II Year)'
                >
                  <InputField name='firstAdmissionClass' />
                </FormRow>
                <FormRow
                  num='10.'
                  label='Whether the people has been declared eligible For promotion.'
                >
                  <SelectField
                    name='qualified'
                    options={booleanValues}
                    placeholder='Select Value'
                  />
                </FormRow>
                <FormRow
                  num='11.'
                  label='(a) Whether the people was in receipt of any scholarship (nature of the Scholarship To be specified) '
                >
                  <SelectField
                    name='scholarship'
                    options={booleanValues}
                    placeholder='Select Value'
                  />
                </FormRow>
                <FormRow
                  num=''
                  label='(b)  Whether the people was in the receipt of Any concession (Nature of the concession be specified)'
                >
                  {' '}
                  <SelectField
                    name='concession'
                    options={booleanValues}
                    placeholder='Select Value'
                  />
                </FormRow>
                <FormRow
                  num='12.'
                  label='Date on which the people as actually left the college '
                >
                  <DateField name='leavingDate' />
                </FormRow>
                <FormRow
                  num='13.'
                  label='Reasons for applying / giving the certificate'
                >
                  <InputField name='reason' />
                </FormRow>

                <FormRow num='14.' label='Conduct' name='conduct'>
                  <SelectField
                    name='conduct'
                    options={conductValues}
                    placeholder='Select Conduct'
                  />
                </FormRow>
                <FormRow
                  num='15.'
                  label='Signature of Head the Institution'
                  name='signature'
                >
                  <InputField name='signature' />
                </FormRow>
              </div>{' '}
              <div className='flex justify-between gap-12 mt-6'>
                <Button
                  variant='contained'
                  color='error'
                  type='button'
                  disabled={!values.tcNumber || isDownloading}
                  onClick={downloadTC}
                >
                  Print/Download
                </Button>{' '}
                <Button
                  variant='contained'
                  type='submit'
                  disabled={isIdExists || isSubmitting}
                >
                  Submit
                </Button>
              </div>
            </div>{' '}
          </Form>
        )}
      </Formik>
      <ToastNotification
        open={notification.open}
        onClose={hideNotification}
        message={notification.message}
        title={notification.title}
        severity={notification.severity}
        autoHideDuration={notification.autoHideDuration}
        position={notification.position}
      />
    </div>
  );
}

/* FORM FIELD ROW */
function FormRow({ num, label, children }) {
  return (
    <div className='grid grid-cols-1 md:grid-cols-2 '>
      <div className='flex items-start gap-4'>
        <div className='w-6'>{num}</div>
        <Typography variant='body1' className='w-[420px]'>
          {label}
        </Typography>
      </div>
      <div className='flex items-start gap-4'>
        <div className='px-1'>:</div>
        <div className='flex-1 ml-4'>{children}</div>
      </div>
    </div>
  );
}

const booleanValues = [
  { label: 'YES', value: true },
  { label: 'NO', value: false },
];
const conductValues = [
  { label: 'Excellent', value: 'Excellent' },
  { label: 'Good', value: 'Good' },
  { label: 'Average', value: 'Average' },
  { label: 'Bad', value: 'Bad' },
];
function InputField({ name, disabled = false }) {
  return (
    <Field name={name}>
      {({ field, meta }) => (
        <TextField
          size='small'
          disabled={disabled}
          variant='standard'
          {...field} // Spreads name, value, onChange, and onBlur
          fullWidth
          // Error handling:
          error={meta.touched && Boolean(meta.error)}
          helperText={meta.touched && meta.error}
        />
      )}
    </Field>
  );
}
function DateField({ name, disabled = false }) {
  return (
    <Field name={name}>
      {({ field, meta }) => (
        <TextField
          disabled={disabled}
          type='date'
          size='small'
          variant='standard'
          {...field} // Spreads name, value, onChange, and onBlur
          fullWidth
          // Error handling:
          error={meta.touched && Boolean(meta.error)}
          helperText={meta.touched && meta.error}
        />
      )}
    </Field>
  );
}
function SelectField({ name = '', options = [], placeholder = '' }) {
  return (
    <Field name={name}>
      {({ field, meta }) => {
        const isError = meta.touched && Boolean(meta.error);

        return (
          <FormControl fullWidth error={isError} variant='standard'>
            <Select
              {...field}
              size='small'

              // This renders the placeholder when the value is empty
              // renderValue={(value) => {
              //   if (!value || value.length === 0) {
              //     return <span style={{ color: '#aaa' }}>{placeholder}</span>;
              //   }
              //   // Find and show the label for the selected value
              //   // return options.find((opt) => opt.value === value)?.label;
              // }}
            >
              {/* Optional: Disabled placeholder item in the dropdown list */}
              <MenuItem value=''>
                <em>{placeholder}</em>
              </MenuItem>

              {options.map((option, index) => (
                <MenuItem key={index} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </Select>

            {/* Error message appears here */}
            {isError && <FormHelperText>{meta.error}</FormHelperText>}
          </FormControl>
        );
      }}
    </Field>
  );
}
